<template>
  <div>
    <v-select
      v-model="parentModel"
      variant="outlined"
      density="compact"
      persistentPlaceholder
      hideDetails
      :items="parentItems"
      itemTitle="name"
      itemValue="value"
      :disabled="disabled"
      placeholder="Select configuration"
      class="segment-builder--subtypes _subtypes"
      height="32px"
      bgColor="#ffffff"
      style="min-width: 180px"
      :menuProps="{ maxHeight: 410, offsetY: true }"
      @update:modelValue="updateParent"
    />
    <div v-if="parentModel" class="segment-builder--item next-selection">
      <RfChevronIcon class="fill-beige-50 mx-1 my-auto h-6 w-6 rotate-180" />
      <v-select
        v-model="childModel"
        multiple
        variant="outlined"
        class="min-w-16"
        density="compact"
        persistentPlaceholder
        hideDetails
        :items="childItems"
        itemTitle="name"
        :disabled="disabled"
        itemValue="value"
        chips
        placeholder="All"
        bgColor="#fff"
        @update:modelValue="updateChild"
      />
    </div>
  </div>
</template>

<script>
import { useAppsStore } from "@/pinia/appsStore";
import {
  Browsers,
  DeviceOSes,
  DeviceTypes,
  Devices,
  getSegmentTypeDevices,
} from "@/utils/constants/DevicesConstants";
import RfChevronIcon from "../icons/RfChevronIcon.vue";

export default {
  name: "RfDevice",
  components: { RfChevronIcon },
  props: ["filter", "disabled"],
  setup: () => ({
    devices: Devices,
    deviceType: Object.values(DeviceTypes),
    deviceOs: Object.values(DeviceOSes),
    browsers: Object.values(Browsers),
    appsStore: useAppsStore(),
  }),
  data: () => ({ parentModel: null, childModel: null }),
  computed: {
    app() {
      return this.appsStore.app;
    },
    parentItems() {
      return Object.values(getSegmentTypeDevices(this.app?.flags?.custom_devices));
    },
    customDevices() {
      return this.app.custom_devices.map(el => ({ name: el.name, value: el.label }));
    },
    parent() {
      return this.parentItems.find(parent => parent.value === this.parentModel);
    },
    child() {
      return this.parent.child;
    },
    childItems() {
      // maps to deviceType, deviceOs, browsers, devices
      return this[this.child];
    },
    device() {
      return this.filter.device;
    },
    deviceKey() {
      return Object.keys(this.device)[0];
    },
    values() {
      if (!this.parent) return [];

      return this.device[this.parent.value];
    },
  },
  mounted() {
    this.prepareFilter();
  },
  methods: {
    updateParent() {
      this.childModel = [];
      this.updateFilter();
    },
    updateChild() {
      this.updateFilter();
    },
    updateFilter() {
      // {"device":{"os_family":["Mac OS X","iOS","Linux"]}}
      const filter = { device: { [this.parentModel]: this.childModel } };

      // tied to v-model:model in RfSegmentBuilder
      // props down events up
      this.$emit("update:model", filter);
    },
    prepareFilter() {
      // filter props comes like that
      // {"device":{"os_family":["Mac OS X","iOS","Linux"]}}
      // first dropdown map to values - type, os, target..
      this.parentModel = this.deviceKey;
      this.childModel = this.values;
    },
  },
};
</script>
